import { mediaQueries } from 'shared/breakpoints';
import styled, { css } from 'styled-components';
import { SectionWrapper, SectionText } from 'styles/Typography.styled';

export const StyledSectionWrapper = styled(SectionWrapper)`
    display: flex;
    padding: 160px 20px 160px;
    align-items: center;

    ${mediaQueries.md} {
        align-items: center;
        padding: 56px 16px;
    }
    ${mediaQueries.sm} {
        flex-direction: column;
    }
`;

export const LeftWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1.6;
    padding-right: 100px;

    ${mediaQueries.sm} {
        padding-right: 0;
    }
`;

export const RightWrapper = styled.div`
    flex: 1;
`;

export const TextDescription = styled(SectionText)(
    ({ theme: { fontWeight, colors } }) =>
        css`
            color: ${colors.neutral300};

            ${mediaQueries.sm} {
                margin-bottom: 40px;
            }
        `,
);

export const Image = styled.img`
    flex: 1;
    max-width: 100%;

    ${mediaQueries.sm} {
        max-height: unset;
        display: none;
    }
`;

export const ImageMobile = styled.img`
    display: none;

    ${mediaQueries.sm} {
        display: block;
        max-width: 100%;
    }
`;
